import assign from 'lodash/assign'
import cloneDeep from 'lodash/cloneDeep'

import * as user from './UserPageActions'

export default (state = user.USER_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case user.USER_BANNER_ADD: {
      return cloneDeep(state)
    }
    case user.USER_BANNER_ADD_CANCELED: {
      return cloneDeep(state)
    }
    case user.USER_BANNER_ADD_ERROR: {
      return assign(cloneDeep(state), { error: action.payload.error })
    }
    case user.USER_BANNER_ADD_FULFILLED: {
      const newState = cloneDeep(state)
      newState.data[0].profile.picture = action.payload.data[0] || {}
      return newState
    }

    case user.USER_FETCH: {
      return cloneDeep(user.USER_INITIAL_STATE)
    }
    case user.USER_FETCH_CANCELED: {
      return cloneDeep(user.USER_INITIAL_STATE)
    }
    case user.USER_FETCH_ERROR: {
      return assign(cloneDeep(state), { data: [], error: action.payload })
    }
    case user.USER_FETCH_FULFILLED: {
      return assign(cloneDeep(state), action.payload)
    }

    case user.USER_LIKE: {
      return cloneDeep(state)
    }
    case user.USER_LIKE_CANCELED: {
      return cloneDeep(state)
    }
    case user.USER_LIKE_ERROR: {
      return cloneDeep(state)
    }
    case user.USER_LIKE_FULFILLED: {
      const liked = action.payload?.data?.[0]?.like
      const newState = cloneDeep(state)

      if (liked) {
        newState.data[0].liked = [
          {
            liked: true,
          },
        ]
        newState.data[0].following = [
          {
            follow: true,
          },
        ]
        newState.data[0].likes_count += 1
        newState.data[0].follows_count += 1
      } else {
        newState.data[0].liked = []
        newState.data[0].following = []
        newState.data[0].likes_count -= 1
        newState.data[0].follows_count -= 1
      }
      return newState
    }
    default:
  }
  return state
}
